import React from "react";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  content?: string;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  content,
  onConfirm,
  onClose,
}) => {
  return (
     <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          minWidth: 360,
          boxShadow: 8,
        },
      }}
    >
      {/* Title with close button */}
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <DialogTitle sx={{ p: 0 }}>
          <Typography sx={{fontSize:'0.975rem'}} fontWeight={600}>
            {title}
          </Typography>
        </DialogTitle>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {content && (
        <DialogContent sx={{ mt: 1 }}>
          <DialogContentText
            sx={{
              fontSize: "0.875rem",
              color: "text.secondary",
              lineHeight: 1.6,
            }}
          >
            {content}
          </DialogContentText>
        </DialogContent>
      )}

      <DialogActions sx={{ px: 2, pb: 2,mt:3 }} >
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 2, textTransform: "none", px: 3 }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            borderRadius: 2,
            textTransform: "none",
            px: 3,
            boxShadow: 2,
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;


export function useConfirmDialog() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [onConfirm, setOnConfirm] = useState<() => void>(() => () => {});

  const openConfirmDialog = (title: string, confirmFn: () => void) => {
    setTitle(title);
    setOnConfirm(() => confirmFn);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return {
    open,
    title,
    onConfirm,
    handleClose,
    openConfirmDialog,
  };
}
